<template>
  <div id="CreateReturnInfo" class="container bg-light pb-5">
    <p class="pl-3 py-4">
      Please take a minute to confirm your contact information.
    </p>
    <form class="needs-validation mb-2 no-gutters" novalidate>
      <div class="form-row mx-3 mb-2">
        <div class="pl-0 pr-2 col-lg-4 col-md-6 col-sm-6">
          <label for="preferredContactMethod">
            <strong>Preferred Contact Method:</strong>
          </label>
          <b-form-select
            id="preferredContactMethod"
            v-model="contactInfo.PreferredContactMethod"
            name="preferredContactMethod"
            class="form-control form-control-sm"
            :options="contactMethods"
            aria-describedby="returnReasonLiveFeedback"
            :select-on-tab="true"
          />
          <b-form-invalid-feedback id="returnReasonLiveFeedback">
            Contact Method is Required
          </b-form-invalid-feedback>
          <b-form-valid-feedback />
        </div>
        <div class="pl-0 pr-2 col-lg-3 col-md-6 col-sm-6">
          <label for="customerName">
            <strong>Name</strong>
          </label>
          <b-form-input
            id="validateCustomerName"
            v-model="contactInfo.ContactName"
            v-validate="{required: true, min: 2, max: 50}"
            name="FullName"
            type="text"
            size="sm"
            class="form-control"
            :state="ValidateState('FullName')"
          />
          <b-form-invalid-feedback
            id="returnReasonLiveFeedback"
          >
            Full Name is Required. Name length must be between 2 and 50 characters.
          </b-form-invalid-feedback>
          <b-form-valid-feedback />
        </div>
        <div class="p-0 col-lg-4 col-md-9 col-sm-9">
          <label for="customerEmail">
            <strong>Email</strong>
          </label>
          <b-form-input
            id="validateCustomerEmail"
            v-model="contactInfo.ContactEmail"
            v-validate="{required: true, email: true, max: 50}"
            name="Email"
            type="text"
            size="sm"
            class="form-control"
            aria-describedby="returnReasonLiveFeedback"
            :state="ValidateState('Email')"
          />
          <b-form-invalid-feedback
            id="returnReasonLiveFeedback"
          >
            Valid Email is Required. Email length must not exceed 50 characters.
          </b-form-invalid-feedback>
          <b-form-valid-feedback />
        </div>
      </div>
      <div class="form-row mx-3 mb-2">
        <div class="pl-0 pr-2 col-lg-4 col-md-6 col-sm-6">
          <label for="customerPhone">
            <strong>Phone Number</strong>
          </label>
          <b-form-input
            id="validateCustomerPhone"
            v-model="contactInfo.ContactPhone"
            v-validate="{required: true, max: 50}"
            name="PhoneNumber"
            type="text"
            size="sm"
            class="form-control"
            :state="ValidateState('PhoneNumber')"
          />
          <b-form-invalid-feedback
            id="returnReasonLiveFeedback"
          >
            Phone Number is Required. Phone Number length must not exceed 50 characters.
          </b-form-invalid-feedback>
          <b-form-valid-feedback />
        </div>
        <div class="pl-0 pr-2 col-lg-4 col-md-6 col-sm-6">
          <label for="nonReturnableActions">
            <strong>Action For Rejected Parts:</strong>
          </label>
          <b-form-select
            id="nonReturnableActions"
            v-model="contactInfo.ActionForNonReturnable"
            v-validate="{required: true, is_not:'Blank'}"
            name="nonReturnableActions"
            class="form-control form-control-sm"
            :options="nonReturnableActions"
            aria-describedby="returnReasonLiveFeedback"
            :state="ValidateState('nonReturnableActions')"
          >
            <template slot="first">
              <option :value="'Blank'" disabled>
                Please Select...
              </option>
            </template>
          </b-form-select>
          <b-form-invalid-feedback id="returnReasonLiveFeedback">
            Non-returnable action is Required.
          </b-form-invalid-feedback>
          <b-form-valid-feedback />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { ReturnsService } from "@/services/ReturnsService"
  import { inputValidateState } from "@/components/mixins/inputValidateState"
  import { stringHelper } from "@/components/mixins/stringHelper"

  export default {
    mixins: [inputValidateState, stringHelper],
    props: {
      contactInfo: {
        type: Object,
        default: () => ({})
      },
      validationState: {
        type: Object,
        default: () => ({}),
        stepOne: { type: Boolean, default: false },
        stepTwo: { type: Boolean, default: false },
        stepThree: { type: Boolean, default: false },
        stepFour: { type: Boolean, default: false }
      }
    },
    data: () => ({
      contactMethods: [],
      nonReturnableActions: []
    }),
    created () {
      ReturnsService.GetPreferredContactMethods().then(contactMethodsResult => {
        this.contactMethods = contactMethodsResult.data
      })
      ReturnsService.GetActionForNonReturnables().then(actionResults => {
        for (let key in actionResults.data) {
          if (actionResults.data.hasOwnProperty(key)) {
            this.nonReturnableActions.push({
              text: this.getEnumWithSpaces(actionResults.data[key]),
              value: actionResults.data[key]
            })
          }
        }
      })
    },
    updated () {
      this.$validator.validateAll().then(result => {
        this.validationState.stepThree = result
      })
    }
  }
</script>
